import React, { Component } from "react"
import styled from "styled-components"
import Breadcrumbs from "../Core/Breadcrumbs"
import breakpoints from "../../styles/breakpoints"
import colors from "../../styles/colors"
import { withTranslation } from "gatsby-plugin-react-i18next"
import { getWeddingLink } from "../../services/links"

const StyledBreadcrumbs = styled(Breadcrumbs)`
  padding-bottom: 8px;
  padding-top: 8px;
  padding-left: 0;
  a,
  li {
    color: ${colors.black} !important;
    font-size: 10px !important;
  }

  @media (min-width: ${breakpoints.lg}) {
    padding-bottom: 0px;
    padding-top: 0px;
    display: block;
  }
`

class ProductBreadcrumbs extends Component {
  render() {
    const { product, collections, wedding, t } = this.props

    let productCategory = false
    let collectionsData = {}
    let categoryLink = false
    let categories = ["rings", "bracelets", "necklaces", "earrings"]

    collections?.forEach((collection) => {
      let collectionData = collection.node;

      if (categories.includes(collectionData.handle)) {
        collectionsData[collectionData.handle] = collectionData.urlKey
      }
    })

    product.tags.forEach((tag) => {
      let lowerCaseTag = tag.toLowerCase()

      if (productCategory !== false) {
        return
      }

      if (collectionsData[lowerCaseTag]) {
        categoryLink = collectionsData[lowerCaseTag]
        productCategory = collectionsData[lowerCaseTag]
      }

      if (collectionsData[lowerCaseTag + "s"]) {
        categoryLink = collectionsData[lowerCaseTag + "s"]
        productCategory = collectionsData[lowerCaseTag + "s"]
      }
    })

    let breadcrumbs = []

    if (wedding) {
      breadcrumbs = [
        {
          label: t("wedding.wedding_band"),
          path: getWeddingLink(),
        },
      ]
    } else {
      breadcrumbs = [
        {
          label: t("core.shop2"),
          path: "/shop-jewelry/",
        },
      ]
    }

    if (productCategory) {
      const categoryLabel =
        productCategory.charAt(0).toUpperCase() + productCategory.slice(1)
      breadcrumbs.push({
        label: categoryLabel,
        path: "/" + categoryLink + "/",
      })
    }

    return (
      <StyledBreadcrumbs
        className={"productBreadcrumbs"}
        links={breadcrumbs}
        current={product.title}
      />
    )
  }
}

export default withTranslation()(ProductBreadcrumbs)
